import { type FC } from "react";
import {
    Button,
    ButtonColour,
    ButtonStyle,
    Icon,
} from "@onshopfront/components";
import { useShopfrontDispatch } from "../../_Bootstrap/hooks";
import { hideDialog } from "../../Actions/Dialogs/DialogActions";
import { ZendeskArticle } from "./ZendeskArticle";

interface Props {
    id: string;
    scrollAnchor?: string;
}

export const ZendeskDialog: FC<Props> = ({ id, scrollAnchor }) => {
    const dispatch = useShopfrontDispatch();

    return (
        <div className="max-w-xl w-[90vw] max-h-[550px] h-viewport flex flex-col">
            <div className="py-4 pl-8 z-10 text-xs bg-white dark:bg-dark-900">
                <Button
                    style={ButtonStyle.Filled}
                    colour={ButtonColour.Neutral}
                    onClick={() => {
                        dispatch(hideDialog());
                    }}
                >
                    <Icon
                        icon={[ "fal", "times" ]}
                        className="mr-2"
                    />
                    Close
                </Button>
            </div>
            <div className="overflow-auto flex-1">
                <ZendeskArticle
                    id={id}
                    scrollAnchor={scrollAnchor}
                />
            </div>
        </div>
    );
};
